
/**
 * 微信分享 (朋友、朋友圈、腾讯微博、qq、QQ空间)
 *  title, // 分享标题
 *  desc, // 分享描述
 *  link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
 *  imgUrl, // 分享图标
 *  shareSuccess, // 成功回调
 *  shareCancel // 取消回调
 */
import wx from 'weixin-jsapi'
import api from '@/utils/api'

export default {
    data() {
        return {
            imgUrl: require('@/assets/images/logo.jpg')
        }
    },
    methods: {
        share({ title, desc, link, imgUrl = `${window.location.origin}${this.imgUrl}` }) {
            const self = this
            const params = {
                url: window.location.href
            }
            api.getWxSdkInfo(params).then((res) => {
                if (res.data) {
                    wx.config({
                        // debug: true,
                        appId: res.data.app_id,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.noncestr,
                        signature: res.data.signature,
                        jsApiList: [
                            'onMenuShareAppMessage',
                            'onMenuShareTimeline',
                            'onMenuShareQQ',
                            'onMenuShareWeibo',
                            'onMenuShareQZone'
                        ]
                    })
                    wx.ready(function() {
                        // 分享给朋友
                        wx.onMenuShareAppMessage({
                            title,
                            desc,
                            link,
                            imgUrl,
                            type: '',
                            dataUrl: '',
                            success: function() {
                                if (self.shareSuccess) self.shareSuccess()
                            }
                        })
                        // 分享到朋友圈
                        wx.onMenuShareTimeline({
                            title,
                            link,
                            imgUrl,
                            success: function() {
                                if (self.shareSuccess) self.shareSuccess()
                            }
                        })
                        // 分享到qq
                        wx.onMenuShareQQ({
                            title,
                            desc,
                            link,
                            imgUrl,
                            success: function() {
                                if (self.shareSuccess) self.shareSuccess()
                            },
                            cancel: function() {
                                if (self.shareCancel) self.shareCancel()
                            }
                        })
                        // 分享到腾讯微博
                        wx.onMenuShareWeibo({
                            title,
                            desc,
                            link,
                            imgUrl,
                            success: function() {
                                if (self.shareSuccess) self.shareSuccess()
                            },
                            cancel: function() {
                                if (self.shareCancel) self.shareCancel()
                            }
                        })
                        // 分享到qq空间
                        wx.onMenuShareQZone({
                            title,
                            desc,
                            link,
                            imgUrl,
                            success: function() {
                                if (self.shareSuccess) self.shareSuccess()
                            },
                            cancel: function() {
                                if (self.shareCancel) self.shareCancel()
                            }
                        })
                    })
                }
            })
        }
    }
}
